import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import Footer from "../footer/footer.component";
import HeaderGuest from "../header/header-guest.component";
import HeaderAuth from "../header/header-auth.component";

const Navigation = () => {
  const { getToken } = AuthUser();
  return (
    <Fragment>
      {!getToken() ? <HeaderGuest /> : <HeaderAuth />}
      <Outlet />
      <Footer />
    </Fragment>
  );
};

export default Navigation;
